/**
 * Computes the company-match status between the launched société (from the desktop session)
 * and the société the AcombaBridge is currently connected to.
 *
 * Rules (per spec §3 + §6.5/§6.6):
 * - 'match'        — both keys are present and equal (case-insensitive hex comparison).
 * - 'mismatch'     — both keys are present and differ: the bridge is connected to a different company.
 * - 'unverifiable' — the bridge's icIdentifiantPublique is absent (a bridge whose credentials were not
 *                    pushed by Acomba); cannot confirm which company the bridge is pointed at.
 * - 'unknown'      — the launched key is absent (portal/AcombaGo session, or token decoding failed);
 *                    the company-match feature does not apply.
 */
export type CompanyMatchStatus = 'match' | 'mismatch' | 'unverifiable' | 'unknown';

export function computeCompanyMatchStatus(
    launchedKey: string | null | undefined,
    bridgeKey: string | null | undefined,
): CompanyMatchStatus {
    if (!launchedKey) return 'unknown';
    if (!bridgeKey) return 'unverifiable';
    return launchedKey.toLowerCase() === bridgeKey.toLowerCase() ? 'match' : 'mismatch';
}
